<div
  class="modal fade"
  id="confirmDialogModal"
  role="dialog"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content">
      <div class="modal-header text-center">
        <h3 id="hdrImageTitle" class="modal-title text">
          {{ title }}
        </h3>
        <button
          type="button"
          class="close float-right text"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onCancel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="required">
                <p class="modal-title" class = "modal-text">
                  {{ message }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content: center;">
        <button
          type="button"
          class="submitbtn"
          (click)="onConfirm()"
        >
          {{ confirmButtonText }}
        </button>
        <!--<button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="onCancel()"
        >
          {{ cancelButtonText }}
        </button>-->
      </div>
    </div>
  </div>
</div>